module.exports = __webpack_public_path__ + "img/selected6-min.59872d48.png";